import React, { useState } from 'react';
import { IconButton } from '@atlaskit/button/new';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const ExpandAllButton = () => {
	// TODO: Implement store for expand all state
	const [isExpanded, setIsExpanded] = useState(false);
	const { formatMessage } = useIntl();

	return (
		<IconButton
			label={
				isExpanded
					? formatMessage(messages.collapseAllTooltip)
					: formatMessage(messages.expandAllTooltip)
			}
			spacing="compact"
			appearance="subtle"
			icon={(iconProps) =>
				isExpanded ? (
					<ChevronDownIcon {...iconProps} size="small" />
				) : (
					<ChevronRightIcon {...iconProps} size="small" />
				)
			}
			onClick={() => setIsExpanded(!isExpanded)}
			isTooltipDisabled={false}
		/>
	);
};
